import { useTranslation } from 'react-i18next';
import React from "react"
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader"
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import { useProductModel } from "../productModel"
export function PageHeader() {
    const { t } = useTranslation();
    const { searchParam, loadData, updateSearchParam, resetSearchParam } = useProductModel()
    const { getSelectedDictOne } = useDictModel()
    const searchFields = [
        {
            type: "Input",
            placeholder: t(`shopping.view.PageHeader.商品名称`),
            fieldName: "name",
        },
        {
            type: "Input",
            placeholder: t(`shopping.view.PageHeader.商品编号`),
            fieldName: "code",
        },
        {
            type: "Select",
            placeholder: t(`shopping.view.PageHeader.品牌`),
            fieldName: "brandCode",
            options: getSelectedDictOne(DictCodeEnmu.MATERIAL_BRAND),
        },
        {
            type: "Select",
            placeholder: t(`shopping.view.PageHeader.上架状态`),
            fieldName: "upStatus",
            options: getSelectedDictOne(DictCodeEnmu.DISPLAY_STATUS),
        },
    ]

    return (
        <YhPageHeader
            title={t(`shopping.view.PageHeader.商品管理`)}
            size="small"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    )
}
